import { CloseButton, Spinner } from '@chakra-ui/react'
import * as C from './styles'
import { useDocument } from '../../../hooks/useDocument'
import { useState } from 'react'
import { ModalConfirmExclude } from '../../Modal/confirmExclude'

interface ImageComponentProps {
  onRemove?: () => void
}

export const ImageComponent = ({ onRemove }: ImageComponentProps) => {
  const { imgSrc, handlerRemoveImage } = useDocument()
  const [isOpen, setIsOpen] = useState(false)



  return (
    <C.Container>
      {imgSrc ? (
        <>
          <img src={imgSrc} alt="perfil" />
          <CloseButton
            bg="white"
            _hover={{ bg: 'red.600', color: 'white' }}
            onClick={() => {
              setIsOpen(true)
            }}
          />
        </>
      ) : (
        <>
          <Spinner size="large" color="blue" />
        </>
      )}
      <ModalConfirmExclude isOpen={isOpen} onClose={() => setIsOpen(false)} title='Deseja remover a imagem?' onConfirmExclude={() => {
        handlerRemoveImage()
        onRemove?.()
      }}>
        <span>Deseja realmente remover a imagem?</span>
      </ModalConfirmExclude>
    </C.Container>
  )
}
